// extracted by mini-css-extract-plugin
export var progressBar = "_j2-0";
export var progressBarInner = "_j2-1";